import React from 'react';

const OverallScoreCard = ({ score }) => {
  const displayScore = score !== undefined && score !== null ? Math.floor(score) : 0;
  const isGood = displayScore >= 50;

  return (
    <div className={`flex items-center gap-5 p-5 rounded-2xl border-2 ${
      isGood
        ? 'bg-emerald-100 dark:bg-emerald-500/10 border-emerald-500 dark:border-emerald-500/40'
        : 'bg-red-100 dark:bg-red-500/10 border-red-500 dark:border-red-500/40'
    }`}>
      <h3 className={`m-0 text-base font-semibold shrink-0 ${
        isGood ? 'text-emerald-800 dark:text-emerald-400' : 'text-red-800 dark:text-red-400'
      }`}>Overall Score</h3>
      <div className={`text-4xl font-semibold leading-none ${
        isGood ? 'text-emerald-800 dark:text-emerald-400' : 'text-red-800 dark:text-red-400'
      }`}>{displayScore}</div>
    </div>
  );
};

export default OverallScoreCard;

